import { bus } from './EventBus.js';

export const Phase = {
  BOOT: 'boot',
  MENU: 'menu',
  PLAYING: 'playing',
  DRAFT: 'draft',      // perk selection (slow-mo)
  FORGE: 'forge',      // formula rearrangement screen
  DEAD: 'dead',
};

// Central mutable run state. Read freely; mutate through the helpers so events fire.
export class GameState {
  constructor() { this.reset(); }

  reset() {
    this.phase = Phase.BOOT;
    this.wave = 0;
    this.waveTimer = 0;
    this.level = 1;
    this.xp = 0;
    this.xpToNext = 12;
    this.pendingPerks = 0;
    this.kills = 0;
    this.shotsFired = 0;
    this.shotsHit = 0;
    this.runTime = 0;
    this.chain = 0;           // Fibonacci chain length
    this.bestChain = 0;
    this.primeCrits = 0;
    this.peakDamage = null;   // BigNum
    this.totalDamage = null;  // BigNum
    this.perks = [];          // perk ids owned
    this.perkSet = new Set();
    this.axiomPoints = 0;
    this.seed = (Math.random() * 0xffffffff) >>> 0;
  }

  setPhase(p) {
    if (this.phase === p) return;
    const prev = this.phase;
    this.phase = p;
    bus.emit('state:phase', { phase: p, prev });
  }

  advanceRunTime(dt) {
    if(this.phase===Phase.PLAYING && Number.isFinite(dt) && dt>0) this.runTime+=dt;
  }

  hasPerk(id) { return this.perkSet.has(id); }

  addPerk(id) {
    if (this.perkSet.has(id)) return false;
    this.perkSet.add(id);
    this.perks.push(id);
    bus.emit('perk:acquired', id);
    return true;
  }

  addXP(n) {
    this.xp += n;
    let leveled = 0;
    while (this.xp >= this.xpToNext) {
      this.xp -= this.xpToNext;
      this.level++;
      leveled++;
      this.pendingPerks++;
      // Gentle curve: early levels come fast, then stretch out.
      this.xpToNext = Math.floor(12 * Math.pow(this.level, 1.42) + this.level * 6);
    }
    if (leveled > 0) bus.emit('player:levelup', { level: this.level, count: leveled });
    bus.emit('xp:changed', { xp: this.xp, next: this.xpToNext, level: this.level });
    return leveled;
  }

  get accuracy() { return this.shotsFired ? this.shotsHit / this.shotsFired : 0; }
}
